'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link href="/" className="flex items-center gap-2">
            <Image
              src="/logo_compressed.png"
              alt="CORTIC Ventures"
              width={140}
              height={50}
            />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              href="/"
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
            >
              Home
            </Link>
            <Link 
              href="/about"
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
            >
              About
            </Link>
            {/*
            <Link 
              href="/projects"
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
            >
              Projects
            </Link>
            */}
            <Link 
              href="/insights"
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
            >
              Innovation Insights
            </Link>
            <Link 
              href="/contact"
              className="px-4 py-2 rounded-md bg-[#0F62FE] text-white text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              Contact
            </Link>
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            type="button"
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            {isMenuOpen ? (
              <X className="block h-6 w-6" aria-hidden="true" />
            ) : (
              <Menu className="block h-6 w-6" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      <div className={cn(
        "md:hidden fixed inset-0 z-40 bg-white w-full h-full transform transition-transform ease-in-out duration-300",
        isMenuOpen ? "translate-x-0" : "translate-x-full",
        // Explicitly ensure full overlay
        "left-0 right-0 top-0 bottom-0"
      )}>
        <div className="flex flex-col p-6 space-y-6 bg-white">
          <div className="flex justify-between items-center">
            <Link
              href="/"
              className="flex items-center gap-2"
              onClick={() => setIsMenuOpen(false)}>
              <Image
                src="/logo_compressed.png"
                alt="CORTIC Ventures"
                width={48}
                height={48}
              />
            </Link>
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              onClick={toggleMenu}
            >
              <span className="sr-only">Close menu</span>
              <X className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <nav className="flex flex-col space-y-6">
            <Link 
              href="/"
              className="text-lg font-medium text-gray-700 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              href="/about"
              className="text-lg font-medium text-gray-700 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            {/*
            <Link 
              href="/projects"
              className="text-lg font-medium text-gray-700 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Projects
            </Link>
            */}
            <Link 
              href="/insights"
              className="text-lg font-medium text-gray-700 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Innovation Insights
            </Link>
            <Link 
              href="/contact"
              className="px-4 py-2 w-full text-center rounded-md bg-[#0F62FE] text-white font-medium hover:bg-blue-700 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
